import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router';
import { clearSession } from '@/stores/session';
import { setUnauthorizedHandler } from '@/api/http';
import './assets/theme.css';

setUnauthorizedHandler(() => {
  clearSession();
  const current = router.currentRoute.value;

  if (current.path.startsWith('/member')) {
    if (current.path !== '/member/login') {
      router.replace({
        path: '/member/login',
        query: current.meta.requiresAuth ? { redirect: current.fullPath } : {}
      });
    }
    return;
  }

  if (current.path.startsWith('/admin') && current.path !== '/admin/login') {
    router.replace({
      path: '/admin/login',
      query: current.meta.requiresAuth ? { redirect: current.fullPath } : {}
    });
  }
});

const app = createApp(App);

Object.entries(ElementPlusIconsVue).forEach(([key, component]) => {
  app.component(key, component);
});

app.use(router);
app.use(ElementPlus, {
  locale: zhCn
});

app.mount('#app');
